import { Loader, Tooltip } from "@mantine/core";
import { IconDeviceFloppy, IconLock } from "@tabler/icons-react";
import { useMemo } from "react";
import { useIsOnline } from "src/hooks";
import { useSelector } from "src/redux/hooks";

const EntryLockInfo = () => {
  const lbName = useSelector(state => state.generatorSlice.latestEntry.lbName);
  const { locked, user, you, isSaving, activeAutosave, lastUpdate } =
    useSelector(state => state.entrySlice);
  const isOnline = useIsOnline();

  const lockedBy = useMemo(
    () =>
      you ? "by You" : user ? `by ${user.rolename} - ${user.full_name}` : "",
    [you, user],
  );

  if (!isOnline) {
    return <></>;
  }

  return (
    <>
      {lbName && locked && (
        <Tooltip color="dark" label={`Entry is locked for editing ${lockedBy}`}>
          <IconLock color={you ? "green" : "red"} />
        </Tooltip>
      )}
      {activeAutosave && isSaving && <Loader size="sm" color="green" />}
      {activeAutosave && !isSaving && lastUpdate && (
        <Tooltip color="dark" label={`Last saved: ${lastUpdate}`}>
          <IconDeviceFloppy color="green" />
        </Tooltip>
      )}
    </>
  );
};

export default EntryLockInfo;
